/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import SearchIcon from "@mui/icons-material/Search";
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Groups2Icon from "@mui/icons-material/Groups2";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import * as Sentry from "@sentry/react";
import EditIcon from "@mui/icons-material/Edit";
import { Helmet } from "react-helmet";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { AlertStatus, Constants, PERMISSIONS } from "../../../contants";
import Loader from "../../../components/common/Loader/Loader";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import style from "./TemplateList.styles";
import { performOperation } from "../../member/MemberSearch/utils";
import NewTable from "../../member/components/Newtable/NewTable";
import useUserConfig from "../../../hooks/useUserConfig";
import styles from "../Components/EmailerTable/EmailerTable.styles";
import Typography from "../../../components/common/new/Typography/Typography";
import Emailer from "../../../services/api/emailer";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Alert from "../../../components/common/new/Alert/Alert";
import ViewTemplate from "../Components/Modal/ViewTemplate";
import { ROUTES } from "../../../utils/constants";

const DOWNLOAD_REPORTS_TABLE_COL = [
  {
    displayName: "Template Type",
  },
  {
    displayName: "Template Name",
  },
  {
    displayName: "Email Subject",
  },
  {
    displayName: "Status",
  },
  {
    displayName: "Created At",
  },
  {
    displayName: "Action",
  },
];

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const LOADER_DELAY = 1000;
const DEFAULT_PAGE_SIZE = 5;

function TemplateList() {
  const TITLE = "Select Template List - BSG";
  const [TemplateData, setTemplateData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalDownloadPages, setTotalPages] = useState(0);
  const [totalTemplateElements, setTotalElements] = useState(0);
  const [downloadSize, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const hasPermission = useUserConfig();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useContext(ToastAlertContext);
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [viewTemplate, setViewTemplate] = useState(false);
  const [htmlData, setHtmlData] = useState([]);
  const [openArchiveAlert, setOpenArchiveAlert] = useState(false);

  console.log("info", selectedTemplate);

  const toggleAlert = (templateInfo) => {
    setSelectedTemplate(templateInfo);
    setOpenAlert((prev) => !prev);
  };

  const toggleArchiveAlert = (templateInfo) => {
    setSelectedTemplate(templateInfo);
    setOpenArchiveAlert((prev) => !prev);
  };

  const toggleVIewTemplate = () => {
    setViewTemplate((prev) => !prev);
  };

  const laoding = useSelector((store) => store.view_friends.isLoading);

  async function fetchData(pageNumber, size) {
    try {
      setIsLoading(true);
      const response = await Emailer.getTemplates({
        pageNumber,
        size,
        sort: "createdAt,DESC",
      });

      if (response.code === 200) {
        const { content, totalPages, totalElements, size } = response.data;
        setCurrentPage(pageNumber);
        setSize(size);
        setTimeout(() => {
          setTotalPages(totalPages);
          setTotalElements(totalElements);
          setTemplateData(content);
          setIsLoading(false);
        }, LOADER_DELAY);
      } else {
        console.error("API Error:", response);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Request Error:", error);
    }
  }

  const onSearchClick = (pageNumber, size) => {
    fetchData(pageNumber, size);
  };

  const onPaginationClick = (page) => {
    onSearchClick(page, downloadSize);
  };
  const onRefresh = () => {
    fetchData(0, DEFAULT_PAGE_SIZE);
  };

  const onPageSizeClick = (operator) => {
    // const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      downloadSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    onSearchClick(0, newPageSize);
  };
  const onSendClick = (templateInfo) => {
    dispatch({ type: "SET_TEMPLATE_INFO", payload: templateInfo });
    navigate("/emailer/templates/add-recipients");
  };

  const onViewRecipients = (templateInfo) => {
    dispatch({ type: "SET_TEMPLATE_INFO", payload: templateInfo });
    navigate(`/emailer/templates/recipients/${templateInfo.id}`);
  };

  const onHitCopy = async (templateInfo) => {
    try {
      setIsLoading(true);
      await Emailer.duplicatedTemplate(templateInfo?.id);
      toast.show("Template copied Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
      toggleAlert(templateInfo);
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
      console.error("Request Error:", error);
    }
  };

  const getHTMLTemplate = async (templateInfo, isZipfile) => {
    try {
      setIsLoading(true);
      const response = await Emailer.getHTMLTemplate(templateInfo?.id);
      setHtmlData(response);
      if (
        isZipfile &&
        response &&
        response?.data &&
        response?.data?.htmlContentUrl
      ) {
        window.open(response?.data?.htmlContentUrl, "_blank");
      }
      setIsLoading(false);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const updateTemplateAction = (id) => {
    navigate(`${ROUTES.EMAILER_UPDATE.path}/${id}`);
  };

  const onHitArchive = async (templateInfo) => {
    try {
      setIsLoading(true);
      await Emailer.archiveTemplate(templateInfo?.id);
      toast.show("Template archive Successfully Done", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
      toggleArchiveAlert(templateInfo);
    } catch (error) {
      setIsLoading(false);
      toast.show(error.message, AlertStatus.ERROR);
      console.error("Request Error:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, downloadSize);
  }, [currentPage, downloadSize]);
  const getRows = (data) =>
    data.map((templateInfo) => {
      const isZipfile = templateInfo?.type === "ZIP_HTML_EMAIL";
      const isShow = templateInfo?.status === "CREATED";
      console.log("file", isZipfile);
      return (
        <TableRow>
          {/* <TableCell>{serialNumber}</TableCell> */}
          {/* <TableCell>{templateInfo.templateName || "-"}</TableCell> */}
          <TableCell>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo.type === "MANUAL_HTML_EMAIL"
                  ? "Text Email"
                  : templateInfo.type === "ZIP_HTML_EMAIL"
                  ? "HTML Zip"
                  : "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell sx={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo.templateName || "NA"}
              </Typography>
            </div>
          </TableCell>
          {/* <TableCell>{templateInfo.subject || "NA"}</TableCell> */}
          <TableCell sx={tabelCellWidth.small}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo.subject || "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell sx={tabelCellWidth.medium}>
            <div style={styles.tableBox}>
              <Typography style={styles.typoghrphyStyle}>
                {templateInfo.status || "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell sx={{ maxWidth: "7rem" }}>
            <div>
              <Typography style={styles.typoghrphyStyle}>
                {moment(templateInfo.createdAt).format(
                  "DD/MM/YYYY, h:mm:ss a"
                ) || "NA"}
              </Typography>
            </div>
          </TableCell>
          <TableCell>
            <Box sx={{ display: "flex", gap: "10px", justifyContent: "left" }}>
              <Tooltip
                title="View Template"
                style={{
                  ...style.actionIcon,
                  color: "#8c8c8c",
                }}
              >
                <VisibilityOutlinedIcon
                  fontSize="small"
                  onClick={() => {
                    if (isZipfile) {
                      getHTMLTemplate(templateInfo, isZipfile);
                      if (
                        htmlData &&
                        htmlData?.data &&
                        htmlData?.data?.htmlContentUrl
                      ) {
                        window.open(htmlData?.data?.htmlContentUrl, "_blank");
                      }
                    } else {
                      toggleVIewTemplate();
                      getHTMLTemplate(templateInfo);
                    }
                  }}
                />
              </Tooltip>
              {!isZipfile &&
                isShow &&
                hasPermission(PERMISSIONS.UPDATE_TEMPlATE) && (
                  <Tooltip
                    title="Update Template"
                    style={{
                      ...style.actionIcon,
                      color: "#8c8c8c",
                    }}
                  >
                    <EditIcon
                      fontSize="small"
                      onClick={() => updateTemplateAction(templateInfo?.id)}
                    />
                  </Tooltip>
                )}
              {hasPermission(PERMISSIONS.COPY_TEMPLATE) && (
                <Tooltip title="Copy">
                  <ContentCopyIcon
                    fontSize="16px"
                    style={{
                      ...style.actionIcon,
                      color: "#8c8c8c",
                      marginTop: "2px",
                    }}
                    onClick={() => {
                      toggleAlert(templateInfo);
                    }}
                  />
                </Tooltip>
              )}
              <Tooltip
                title="View Recipients"
                style={{
                  ...style.actionIcon,
                  color: "#8c8c8c",
                }}
              >
                <Groups2Icon
                  fontSize="small"
                  onClick={() => onViewRecipients(templateInfo)}
                />
              </Tooltip>
              {hasPermission(PERMISSIONS.ADD_RECIPIENTS) && (
                <Tooltip title="Add Recipients">
                  <GroupAddIcon
                    style={{
                      ...style.actionIcon,
                      color: "#8c8c8c",
                    }}
                    fontSize="small"
                    onClick={() => onSendClick(templateInfo)}
                  />
                </Tooltip>
              )}
              <Tooltip title="Archive">
                <ArchiveOutlinedIcon
                  style={{
                    ...style.actionIcon,
                    color: "#8c8c8c",
                    marginTop: "2px",
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    toggleArchiveAlert(templateInfo);
                  }}
                />
              </Tooltip>
            </Box>
          </TableCell>
        </TableRow>
      );
    });
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box sx={style.container}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: "1rem",
          }}
        >
          <Box style={styles.reload} onClick={onRefresh}>
            <ReloadIcon />
          </Box>
        </Box>
        {TemplateData?.length ? (
          <Box style={style.tableContainer}>
            <Box style={style.tableHeading}>
              <Box style={style.tableTitle}>Available Templates</Box>
              <Box style={style.tableInfo}>
                Total Templates: {totalTemplateElements}
              </Box>
            </Box>
            <NewTable
              scrollable
              columns={DOWNLOAD_REPORTS_TABLE_COL}
              rows={getRows(
                TemplateData,
                currentPage,
                downloadSize,
                hasPermission
                //   navigate
              )}
              // hasAction
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
                textAlign: "left",
              }}
              hasPermission
            />
            <Box style={style.pagination}>
              <Pagination
                totalPages={totalDownloadPages}
                totalResults={totalTemplateElements}
                currentPage={currentPage}
                pageSize={downloadSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </Box>
          </Box>
        ) : (
          !TemplateData?.length &&
          laoding === false && (
            <Box style={style.emptyContainer}>
              <h1 style={style.noDataMsg}>No Results</h1>
            </Box>
          )
        )}
        {isLoading && <Loader />}
        <Alert
          open={openAlert}
          onClose={() => toggleAlert(null)}
          onSubmit={() => onHitCopy(selectedTemplate)}
        />
        <Alert
          open={openArchiveAlert}
          onClose={() => toggleArchiveAlert(null)}
          onSubmit={() => onHitArchive(selectedTemplate)}
        />
        <ViewTemplate
          open={viewTemplate}
          onClose={() => toggleVIewTemplate(null)}
          selectedTemplate={selectedTemplate}
          htmlData={htmlData}
          isLoading={isLoading}
        />
      </Box>
    </>
  );
}

export default TemplateList;
